export default "__VITE_ASSET__BAj6fbEs__"